import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ASSESSMENT_FEATURE_KEY } from './keys';
import { assessmentReducer } from './reducers/assessment.reducer';
import { AssessmentEffects } from './effects/assessment.effects';

export function provideAssessmentStore(): EnvironmentProviders[] {
    return [provideState(ASSESSMENT_FEATURE_KEY, assessmentReducer), provideEffects(AssessmentEffects)];
}
